import { GetStaticProps } from "next"
import { AlgoliaIndexes, DomainObjects } from "projectlink-common"
import Explore from "src/common/Explore"
import initServerIndex from "src/search/algoliaServer"
import topicsService from "src/server/services/topics"

function ExplorePage(props) {
  return (
    <Explore {...props} />
  )
}

export const getStaticProps: GetStaticProps = async (_ctx) => {
  const index = initServerIndex(AlgoliaIndexes.main)
  const { hits: projects } = await index.search('', {
    filters: `type:${DomainObjects.project} AND status:published`,
    hitsPerPage: 6,
  })
  const { hits: orgs } = await index.search('', {
    filters: `type:${DomainObjects.organization} AND status:published`,
    hitsPerPage: 6,
  })

  const initialTopics = await topicsService.getAll({ sort: true })

  return {
    props: {
      initialTopics,
      orgs,
      projects,
    },
    revalidate: 30,
  }
}

export default ExplorePage
